import {
    StatusContainer,
    ApplicationSubmitToDecisionGate,
} from '@servicetitan/financing-utils-shared';
import { ExploreMoreOptions, SecondLookFinancingOption } from '../second-look';
import DeclinedIllustration from '../../common/illustrations/unable-to-load.svg';
import { useProviderConfig } from '@servicetitan/financing-workflow-shared';

export const Declined = () => {
    const { defaultWorkflowStage } = useProviderConfig();
    const isExternalApplication = defaultWorkflowStage === 'external-application';
    const providerConfig = useProviderConfig();

    return (
        <ApplicationSubmitToDecisionGate>
            <StatusContainer
                headline={isExternalApplication ? '' : (providerConfig.declinedHeadline ?? '')}
                message={isExternalApplication ? undefined : providerConfig.declinedMessage}
                image={DeclinedIllustration}
            >
                <SecondLookFinancingOption />
                <ExploreMoreOptions />
            </StatusContainer>
        </ApplicationSubmitToDecisionGate>
    );
};
